
    const googleTagID = (import.meta.env?.VITE_GOOGLE_TAG_ID ?? "").trim();
    const initGtag = () => {
      if (!googleTagID) return;
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googleTagID}`;
      script.async = true;
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); } // minimal shim
      gtag("js", new Date());
      gtag("config", googleTagID);
    };
    if (googleTagID) {
      if ("requestIdleCallback" in window) {
        // @ts-ignore
        requestIdleCallback(initGtag);
      } else {
        window.addEventListener("load", initGtag);
      }
    }
  